import _ from 'lodash';
import DefaultState   from './DefaultState';

import { PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';

const state = {
  ...DefaultState,
}

if(Spree.assembly){
  const {quote, quote_parameters, line_item_id} = Spree.assembly;
  state.quantitiesChanged = true
  state.lineItemId = line_item_id;
  state.quote = quote;

  if (!quote_parameters.bga) quote_parameters.bga = "0";
  state.parameters = Object.assign({}, state.parameters, quote_parameters);

  state.quoteStep = _.isNil(state.parameters.row_selected) || _.isNil(state.parameters.column_selected) ? QUOTED : PRICE_SELECTED;
}

export default state;